export function resolveTenantMailRecipient(tenantKey: string | null): string {
	switch (tenantKey) {
		case 'lvr':
			return 'klifd@lvr.de';
		case 'thue':
			return 'christiane.hartmann@tlvwa.thueringen.de';
		case 'bre':
			return 'klifd-support@avib.bremen.de';
		case 'lwl':
			return 'klifd@lwl.org';
		case 'saa':
			return 'klifd@lvwa.sachsen-anhalt.de';
		default:
			return 'klifd@lvr.de';
	}
}
